import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';

const menuItemEnable = ({ cb, path, visible = true }) => ({
  key: 'itemEnable',
  visible,
  label: <LocalizedMessage id="button.enable" />,
  icon: 'btnEnable',
  handleAction: cb,
  path,
});
const menuItemDisable = ({ cb, path, visible = true }) => ({
  key: 'itemDisable',
  visible,
  label: <LocalizedMessage id="button.disable" />,
  icon: 'btnDisable',
  handleAction: cb,
  path,
});
const menuItemSettings = ({ cb, path, visible = true }) => ({
  key: 'itemSettings',
  visible,
  label: <LocalizedMessage id="button.configure" />,
  icon: 'btnEdit',
  handleAction: cb,
  path,
});
const menuItemShow = ({ cb, path, visible = true }) => ({
  key: 'itemShow',
  visible,
  label: <LocalizedMessage id="button.edit" />,
  icon: 'btnEdit',
  handleAction: cb,
  path,
});
const menuItemDelete = ({ cb, path, visible = true }) => ({
  key: 'itemDelete',
  visible,
  label: <LocalizedMessage id="button.delete" />,
  icon: 'btnDelete',
  handleAction: cb,
  path,
});
const menuItemAddToCompany = ({ cb, path, visible = true }) => ({
  key: 'itemAddToCompany',
  visible,
  label: <LocalizedMessage id="button.addToCompany" />,
  icon: 'btnAddTo',
  handleAction: cb,
  path,
});
const menuItemTrigger = ({ cb, path, visible = true }) => ({
  key: 'itemTrigger',
  visible,
  label: <LocalizedMessage id="button.trigger" />,
  icon: 'btnTrigger',
  handleAction: cb,
  path,
});
const menuItemDownloadFile = ({ cb, path, visible = true }) => ({
  key: 'itemDownload',
  visible,
  label: <LocalizedMessage id="button.downloadFile" />,
  icon: 'btnDownloadFile',
  handleAction: cb,
  path,
});
const menuItemPlannings = ({ cb, path, visible = true }) => ({
  key: 'itemPlannings',
  visible,
  label: <LocalizedMessage id="button.plannings" />,
  icon: 'btnPlanning',
  handleAction: cb,
  path,
});
const menuItemAntipassbacks = ({ cb, path, visible = true }) => ({
  key: 'itemAntipassbacks',
  visible,
  label: <LocalizedMessage id="button.antipassbacks" />,
  icon: 'btnAntipassback',
  handleAction: cb,
  path,
});

export const settingsDeleteMenuItems = (settingsObj, deleteObj) => ([menuItemSettings(settingsObj), menuItemDelete(deleteObj)]);

export const showDeleteMenuItems = (showObj, deleteObj) => ([menuItemShow(showObj), menuItemDelete(deleteObj)]);

export const disableDeleteMenuItems = (disableObj, deleteObj) => ([menuItemDisable(disableObj), menuItemDelete(deleteObj)]);

export const enableDeleteMenuItems = (enableObj, deleteObj) => ([menuItemEnable(enableObj), menuItemDelete(deleteObj)]);

export const customerActionsMenuItems = (antipassbackObj, planningObj) => ([menuItemAntipassbacks(antipassbackObj), menuItemPlannings(planningObj)]);

export const companyItemMenuItems = (addObj, settingsObj, deleteObj) => ([menuItemAddToCompany(addObj), menuItemSettings(settingsObj), menuItemDelete(deleteObj)]);

export const doorMenuItems = (showObj, deleteObj, triggerObj) => ([menuItemShow(showObj), menuItemDelete(deleteObj), menuItemTrigger(triggerObj)]);

export const rightMenuItems = (showObj, deleteObj) => ([menuItemShow(showObj), menuItemDelete(deleteObj)]);

export const rightListMenuItems = (triggerObj) => ([menuItemTrigger(triggerObj)]);

export const distributionMenuItems = (showObj, downloadObj, deleteObj) => ([menuItemShow(showObj), menuItemDownloadFile(downloadObj), menuItemDelete(deleteObj)]);



// WEBPACK FOOTER //
// ./utils/MenuItems.js